/** Thread refetch handlers — run after offline sends replay completes. */

const refetchHandlers = new Set();

export function registerOfflineSendRefetchHandler(handler) {
  refetchHandlers.add(handler);
  return () => {
    refetchHandlers.delete(handler);
  };
}

export function runOfflineSendRefetchHandlers() {
  refetchHandlers.forEach((handler) => {
    try {
      handler();
    } catch (err) {
      console.warn('[mutations] offline send refetch handler failed:', err);
    }
  });
}
